<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Confirm Booking'"
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="customBackRoute ? customBackRoute : 'book-job'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-extra-bottom-padding' : ''">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (customFlowName) {
      <tidy-row>
        <tidy-text
          [body]="customFlowName" /><span>&nbsp;</span>
        <tidy-text
          [body]="'offers a'" /><span>&nbsp;</span>
        <tidy-text
          [body]="customFlowDiscount" /><span>&nbsp;</span>
        <tidy-text
          [body]="'% discount on all cleanings.'" />
      </tidy-row>
    }

    <tidy-card>
      <tidy-row class="no-padding">
        <ion-row>
          <tidy-row style="align-self: flex-start">
            <tidy-image
              [src]="viewData?.isHouseCleaning ? 'https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg' : (viewData?.image || 'https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg')"
              style="width: 30px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="viewData?.service | titlecase" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="viewData?.frequency" />
            </tidy-row>
            @if (!isProRequest && !isJobRequest) {
              <tidy-text
                [body]="viewData?.dateTime" />
            }
            @if (viewData?.dateTimeTwo) {
              <tidy-row>
                <tidy-text
                  [body]="viewData?.dateTimeTwo" />
              </tidy-row>
            }
            @if (viewData?.dateTimeThree) {
              <tidy-row>
                <tidy-text
                  [body]="viewData?.dateTimeThree" />
              </tidy-row>
            }
            @if (isJobRequest) {
              <tidy-row>
                <tidy-text
                  [body]="'Earliest:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="(requestDates?.startDate | parseDateTime:'ddd MMM d') + ' ' + (bookData?.booking?.start_time_no_earlier_than | parseDateTime:'h:mma')" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'Latest:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="(requestDates?.endDate | parseDateTime:'ddd MMM d') + ' ' + (bookData?.booking?.end_time_no_later_than | parseDateTime:'h:mma')" />
              </tidy-row>
            }
            @if (isProRequest) {
              <tidy-row>
                <tidy-text
                  [body]="'Times Requested:'" />
              </tidy-row>
              @for (time of requests.buildRequestTimeRangeList(payload?.request_time_blocks); track time; let last = $last) {
                <tidy-row>
                  <tidy-text
                    [body]="time" />
                </tidy-row>
              }
            }
            @if (giftCode?.amount) {
              <tidy-row>
                <tidy-text
                  [helper]="giftCode?.amount | tcurrency" /><span>&nbsp;</span>
                <tidy-text
                  [helper]="'gift code applied'" /><span>&nbsp;</span>
                @if (giftCode?.giver_name) {
                  <tidy-text
                    [helper]="'from'" />
                  <tidy-text
                    [helper]="giftCode?.giver_name"
                    [translate]="false" />
                }
              </tidy-row>
            }
            @if (giftCode?.gift_instructions) {
              <tidy-row>
                <tidy-text
                  [helper]="'Instructions:'" /><span>&nbsp;</span>
                <tidy-text
                  [helper]="giftCode?.gift_instructions" />
              </tidy-row>
            }
          </ion-col>
        </ion-row>
      </tidy-row>
      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-divider/>
      </tidy-row>
      @if (loaded) {
        @if (creditBalance > 0) {
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/checkmark-circle.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Credit Applied'" />
          </tidy-row>
          <tidy-row>
            @if (creditBalance < viewData?.price) {
              <tidy-text
                [body]="'You have'" /><span>&nbsp;</span>
              <tidy-text
                [body]="creditBalance | tcurrency" /><span>&nbsp;</span>
              <tidy-text
                [body]="'in credit'" /><span>&nbsp;</span>
              @if (employerName && employerName !== 'undefined') {
                <tidy-text
                  [body]="'from'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="employerName"
                  [translate]="false" /><span>&nbsp;</span>
              }
              <tidy-text
                [body]="'that will automatically be used for this job.'" />
            }
            @if (creditBalance >= viewData?.price) {
              <tidy-text
                [body]="'You have'" /><span>&nbsp;</span>
              <tidy-text
                [body]="creditBalance | tcurrency" /><span>&nbsp;</span>
              <tidy-text
                [body]="'in credit'" /><span>&nbsp;</span>
              @if (employerName && employerName !== 'undefined') {
                <tidy-text
                  [body]="'from'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="employerName"
                  [translate]="false" /><span>&nbsp;</span>
              }
              <tidy-text
                [body]="', enough to pay for this job in full. We still require a card on file but you will not be charged.'" />
            }
          </tidy-row>
        }
        @if (viewData?.billingType === 'price_later') {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'This type of job is typically priced after. We\'ll find the best pro and you can discuss pricing with them. Please add a credit card to secure the job. '" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'<b>You will not be charged until the job is complete.</b>'" />
          </tidy-row>
        } @else {
          <tidy-row>
            <form [formGroup]="form">
              <tidy-radio-button
                [label]="'How do you want to pay?'"
                formControlName="chargeType"
                [form]="form.controls.chargeType"
                [items]="paymentOptions"
                class="no-margin-first"
                (optionChange)="changePrice($event)" />
            </form>
          </tidy-row>
          @if (showSameDayTimeAlert && (!hasPrivatePros && !hasNoPrivatePros || hasNoPrivatePros && !hasPrivatePros)) {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'<b>*Note:</b> You selected times today. If a Pro accepts a time today the job price will be'" /><span>&nbsp;</span>
              <tidy-text
                [body]="(sameDayPrice | tcurrency) + '.'" />
            </tidy-row>
          }
        }
      }
      <tidy-row>
        <form class="checkout">
          @if (!stripeReady) {
            <div class="form-row">
              <ion-skeleton-text animated style="width: 100%; height: 22px; margin: 0;" />
            </div>
          }
          <div class="form-row" [class.stripe-loading]="!stripeReady">
            <div id="card-info" #cardInfo></div>
          </div>
        </form>
      </tidy-row>
      @if (!(bookingExperiment === 'consumer-test2' && viewData?.frequency === 'One Time')) {
        @if (!giftCode && !customFlowName) {
          <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
            <tidy-text
              [actionBody]="'Referral / Gift Code'"
              (action)="giftCodeForm = true"
              class="link"
              [rippleEffect]="false" />
            <div class="vertical-align-center">
              <tidy-checkbox
                [(checked)]="termsChecked"
                [items]="[{viewValue: '', value: true}]"
                [initValue]="termsChecked" />
              <tidy-text
                [body]="'I agree to the'" /><span>&nbsp;</span>
              <tidy-text
                (action)="openTerms()"
                [body]="'terms'"
                [rippleEffect]="false"
                class="link no-left-margin" />
            </div>
          </tidy-row>
        } @else {
          <tidy-row class="vertical-align-center">
            <tidy-checkbox
              [(checked)]="termsChecked"
              [items]="[{viewValue: '', value: true}]"
              [initValue]="termsChecked" />
            <tidy-text
              [body]="'I agree to the'"/><span>&nbsp;</span>
            <tidy-text
              (action)="openTerms()"
              [body]="'terms'"
              [rippleEffect]="false"
              class="link no-left-margin" />
          </tidy-row>
        }
        @if (giftCodeForm) {
          <tidy-row class="extra-top-padding">
            <form [formGroup]="giftForm">
              <tidy-input
                [label]="'Referral/Gift Code'"
                [icon]="'assets/svg/gift.svg'"
                formControlName="giftCode"
                [form]="giftForm.controls.giftCode"/>
            </form>
          </tidy-row>
          @if (giftCodeErrorMessage && giftForm?.value?.giftCode) {
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="giftCodeErrorMessage"
                class="red" />
            </tidy-row>
          }
          @if (giftCode && !giftCodeErrorMessage) {
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="'Code successfully applied!'"
                class="green" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-text
              [body]="'We apply credit from your referral/gift code first before charging. If your code covers the full cleaning, you won\'t be charged at all. For the safety of your booked cleaning person, we do require a card on file.'" />
          </tidy-row>
        }
      }
      @if (customFlowName) {
        <tidy-row class="extra-top-padding">
          <tidy-text
            [header]="'Enter Contact Detail'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="firstName"
              [form]="form.controls.firstName"
              [label]="'First Name'"
              [errorMessage]="'Please enter your first name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="lastName"
              [form]="form.controls.lastName"
              [label]="'Last Name'"
              [errorMessage]="'Please enter your last name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="email"
              [form]="form.controls.email"
              [label]="'Email'"
              type="email"
              [errorMessage]="'Please enter a valid email.'"
              [submitted]="submitted"
              [icon]="'assets/svg/mail.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input-international-phone
              formControlName="phone"
              [label]="'Phone'"
              [form]="form.controls.phone"
              [inputMode]="'numeric'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid phone.'"
              [icon]="'assets/svg/phone-portrait.svg'"
              [initialMask]="{ mask: '[00000000000000000000000]' }"
              (countryCodeChange)="onCountryCodeChange($event)" />
          </tidy-row>
        </form>
      }
    </tidy-card>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (termsError) {
      <tidy-row>
        <tidy-error-message
          [text]="'You must agree to the terms to continue.'" />
      </tidy-row>
    }

    <tidy-button
      [text]="buttonTitle"
      [action]="boundConfirmBooking"
      class="primary" />

    <tidy-alert class="social-proof-card black-background">
      <div class="review-content">
        <tidy-image
          [src]="'assets/img/social-1.png'"
          class="profile-avatar" />
        <div class="review-text">
          <tidy-text [header]="'Top Ranked on Google!'" />
          <div class="testimonial-text">
            <tidy-text
              [helper]="'&quot;Amazing job! Her thoroughness was superb. The little things made it all the better!&quot; - Dawn R.'" />
          </div>
        </div>
      </div>
      <div class="google-row">
        <tidy-image
          [src]="'assets/img/google.svg'"
          class="google-logo" />
        <div class="rating-info">
          <tidy-image
            [src]="'assets/img/4_5_stars.svg'"
            class="stars-image" />
          <tidy-text [helper]="'4.5 • 1,000+ reviews'" />
        </div>
      </div>
    </tidy-alert>

    <tidy-alert class="black-background">
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [header]="'Why Book With TIDY?'" />
      </tidy-row>

      @if (!selectedPrivatePro) {
        <div class="benefit-item">
          <tidy-image
            [src]="'assets/svg/shield-checkmark.svg'"
            class="benefit-icon white-icon" />
          <div class="benefit-content">
            <tidy-text
              [body]="'<b>Satisfaction Guarantee</b>'" />
            <tidy-text
              [helper]="'Unhappy with your first cleaning? Get a new one free.'" />
          </div>
        </div>
      }

      <div class="benefit-item">
        <tidy-image
          [src]="'assets/svg/calendar.svg'"
          class="benefit-icon white-icon" />
        <div class="benefit-content">
          <tidy-text
            [body]="'<b>Cancel Any Time</b>'" />
          <tidy-text
            [helper]="'Most pros ask 24 hours notice. No long-term commitment.'" />
        </div>
      </div>

      @if (!selectedPrivatePro) {
        <div class="benefit-item">
          <tidy-image
            [src]="'assets/svg/checkmark-done-circle.svg'"
            class="benefit-icon white-icon" />
          <div class="benefit-content">
            <tidy-text
              [body]="'<b>Fully Customizable</b>'" />
            <tidy-text
              [helper]="'Your cleaning, your way. Include anything you like.'" />
          </div>
        </div>
      }
    </tidy-alert>

    @if (!selectedPrivatePro) {
      <tidy-alert class="black-background">
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-text
            [header]="'What\'s Included?'" />
        </tidy-row>

        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'All cleanings are completely customized by you. You selected a '" />
          <tidy-text
            [body]="'<b>' + viewData?.service + '</b> '" />
          @if (viewData?.service === '1 hour cleaning') {
            <tidy-text
              [body]="'which is great for light or very focused cleanings.'" />
          }
          @if (viewData?.service === '2.5 hour cleaning') {
            <tidy-text
              [body]="'which is great for a deeper cleaning of a small home, or a reasonable cleaning in most rooms of a 2 bedroom home.'" />
          }
          @if (viewData?.service === '4 hour cleaning') {
            <tidy-text
              [body]="'which is great for most homes, if you need a load or 2 of laundry done, and gives enough time to get to most checklist items in a 3 bedroom home.'" />
          }
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-text
            [body]="'<b>Popular requests include:</b>'" />
        </tidy-row>

        <tidy-grid>
          <ion-row>
            <ion-col size="12" sizeMd="4">
              <tidy-row class="extra-top-padding">
                <tidy-text
                  [body]="'🛋️'"
                  style="margin-right: 5px" />
                <tidy-text
                  [body]="'<b>Living Areas</b>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Dust surfaces'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Wipe mirrors & glass'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Mop & vacuum floors'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Run laundry & dryer'" />
              </tidy-row>
            </ion-col>
            <ion-col size="12" sizeMd="4">
              <tidy-row class="extra-top-padding">
                <tidy-text
                  [body]="'🚿'"
                  style="margin-right: 5px" />
                <tidy-text
                  [body]="'<b>Bathroom</b>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Sanitize toilet & tub'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Clean shower & sink'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Wipe mirrors'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Mop floors'" />
              </tidy-row>
            </ion-col>
            <ion-col size="12" sizeMd="4">
              <tidy-row class="extra-top-padding">
                <tidy-text
                  [body]="'🍳'"
                  style="margin-right: 5px" />
                <tidy-text
                  [body]="'<b>Kitchen</b>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Wipe appliances'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Clean inside fridge'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Load dishwasher'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'• Take out garbage'" />
              </tidy-row>
            </ion-col>
          </ion-row>
        </tidy-grid>
      </tidy-alert>
    }

    <tidy-row class="vertical-align-middle" [align]="'center'">
      @if (windowService.isDesktopRes) {
        <tidy-image
        [src]="'assets/svg/mail-outline.svg'"
        class="body-size white-icon" />
      }
      <tidy-text
        [helper]="'Need an alternate agreement? Contact '" />
      <tidy-text
        [helper]="'sales@tidy.com'"
        class="link"
        [rippleEffect]="false"
        (action)="util.openUrl('mailto:sales@tidy.com')" />
    </tidy-row>

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}